import { useCallback, useState } from "react";
import { TabObj } from "../interface/tab";

export interface TabStatus {
    tabPanes: TabObj[]
    setTabPanes: (panes: TabObj[]) => void
    addTabPanel: (name: string, type: string, key: string, closable?: boolean, subType?: string) => void
    removeTabPanel: (url: string) => void
    clearTabPanels: () => void

    currentTab: TabObj
    activeTab: (url: string) => void
    
    needRender: () => void
}

export function useTabService() {
    const [tabPanes, setTabPanes] = useState<TabObj[]>([]);
    const [currentTab, setCurrentTab] = useState<TabObj>(null);
    const [renderFlag, setRenderFlag] = useState<boolean>(false);

    const addTabPanel = useCallback((name: string, type: string, key: string, closable = true, subType: string = null) => {
        let url = `${type}/${key}/`
        if (subType) {
            url += `${subType}/`
        }
        let index = tabPanes.findIndex(item => item.url === url);
        if (index < 0) {
            let newTab = { title: name, type: type, key: key, url: url, closable: closable, subType: subType };
            setTabPanes([...tabPanes, newTab]);
            setCurrentTab(newTab);
        } else {
            setCurrentTab(tabPanes[index])
        }
    }, [tabPanes, currentTab])

    const removeTabPanel = useCallback((url: string) => {
        let tmp = tabPanes.filter(item => item.url !== url);
        setTabPanes(tmp);
        if (currentTab.url === url) {
            if (tmp?.length > 0) {
                setCurrentTab(tmp[tmp?.length - 1 || 0]);
            } else {
                setCurrentTab(null);
            }
        }
    }, [tabPanes, currentTab])

    const clearTabPanels = useCallback(() => {
        setTabPanes([]);
        setCurrentTab(null);
    }, [tabPanes, currentTab])

    const activeTab = useCallback((url: string) => {
        let index = tabPanes.findIndex(item => item.url === url);
        setCurrentTab({ ...tabPanes[index] });
    }, [tabPanes, currentTab])

    const needRender = useCallback(() => {
        setRenderFlag(pre => !pre);
    }, [renderFlag])

    return {
        tabPanes,
        setTabPanes,
        addTabPanel,
        removeTabPanel,
        clearTabPanels,
        currentTab, setCurrentTab,
        activeTab,
        renderFlag, needRender,
    }
}